export default {"en-US": __webpack_public_path__ + "i18n/en-US.3c555b49.i18next.json","ja-JP": __webpack_public_path__ + "i18n/ja-JP.4c70e0a9.i18next.json"};